const BRAND = "BlobHub";
const BRAND_SEPARATOR = " · ";
const PART_SEPARATOR = " / ";

/**
 * Writes document.title. Sole owner of the brand suffix and the separators, so the format is
 * changed in one place rather than at every call site.
 *
 * Entity pages call set() twice: once on mount with the alias from the route params, which is
 * available synchronously, and again from the load callback with the resolved name. That is why
 * unresolved parts must be dropped silently — the first call is expected to be partial.
 */
export default class Title {
  /**
   * Title.set("Acme", "Order Pipeline") → "Acme / Order Pipeline · BlobHub"
   */
  static set(...parts) {
    const usable = parts
      .filter(part => typeof part === "string" || typeof part === "number")
      .map(part => String(part).trim())
      .filter(part => part.length > 0);

    if (0 === usable.length) {
      Title.setRoot();
      return;
    }

    document.title = usable.join(PART_SEPARATOR) + BRAND_SEPARATOR + BRAND;
  }

  /**
   * The landing page, and the fallback whenever nothing else resolves.
   */
  static setRoot() {
    document.title = BRAND;
  }

  static setNotFound() {
    document.title = "Not Found" + BRAND_SEPARATOR + BRAND;
  }
}
